import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Mail, ArrowLeft, CheckCircle, Loader2 } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import api from '../lib/api';
import useSEO from '../hooks/useSEO';

export default function ForgotPassword() {
  useSEO({ title: 'Forgot password — EpisodeKit', path: '/forgot-password', index: false });
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('form'); // form | loading | sent
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('loading');
    try {
      const res = await api.post('/auth/forgot-password', { email });
      setStatus('sent');
      setMessage(res.data.message);
    } catch (err) {
      setStatus('sent');
      setMessage(err.response?.data?.detail || 'If an account exists with that email, a password reset link has been sent.');
    }
  };

  return (
    <div className="min-h-screen bg-neutral-950 flex items-center justify-center px-4">
      <div className="max-w-md w-full bg-neutral-900 border border-neutral-800 rounded-xl p-8" data-testid="forgot-password-page">
        {status === 'form' && (
          <>
            <Mail className="w-10 h-10 text-violet-400 mx-auto mb-4" />
            <h1 className="text-xl font-bold text-white text-center mb-2">Forgot Password</h1>
            <p className="text-neutral-400 text-sm text-center mb-6">Enter your email and we'll send you a link to reset your password.</p>
            <form onSubmit={handleSubmit} className="space-y-4">
              <Input
                type="email"
                placeholder="your@email.com"
                value={email}
                onChange={e => setEmail(e.target.value)}
                className="bg-neutral-800 border-neutral-700 text-white"
                data-testid="forgot-email-input"
                required
              />
              <Button type="submit" className="bg-violet-600 hover:bg-violet-700 w-full" data-testid="forgot-submit">
                Send Reset Link
              </Button>
            </form>
          </>
        )}
        {status === 'loading' && (
          <div className="text-center">
            <Loader2 className="w-10 h-10 text-violet-500 animate-spin mx-auto mb-4" />
            <p className="text-neutral-400">Sending reset link...</p>
          </div>
        )}
        {status === 'sent' && (
          <div className="text-center">
            <CheckCircle className="w-12 h-12 text-emerald-400 mx-auto mb-4" />
            <h1 className="text-xl font-bold text-white mb-2">Check Your Email</h1>
            <p className="text-neutral-400 text-sm mb-6">{message}</p>
            <p className="text-neutral-500 text-xs mb-4">Don't see it? Check your spam folder.</p>
          </div>
        )}
        <div className="mt-6 text-center">
          <Link to="/login" className="text-sm text-neutral-500 hover:text-neutral-300 inline-flex items-center gap-1">
            <ArrowLeft className="w-3 h-3" /> Back to Login
          </Link>
        </div>
      </div>
    </div>
  );
}
